import firebase from 'firebase';
// "https://acacya-2017v1-327a1.firebaseio.com/" TESTING
// "https://acacya-2017v1.firebaseio.com/" PRODUCCION
// "https://testacacya.firebaseio.com/" TESTING
var config = {
	apiKey: "AIzaSyBdCjXuky1ONLSSk-Zwfv0fG3opQnSRmGU",
	authDomain: "acacya-2017v1.firebaseapp.com",
	databaseURL: "https://acacya-2017v1.firebaseio.com/",
	projectId: "acacya-2017v1",
	storageBucket: "acacya-2017v1.appspot.com",
	messagingSenderId: "460102106496"
};
firebase.initializeApp(config);

const database = firebase.database();
export default database;


// WEBPACK FOOTER //
// ./src/Components/BD/database.js